export const REDEEM_STORE_VOUCHER_ERROR =
  'REDEEM_STORE_VOUCHER_ERROR';
export const REDEEM_STORE_VOUCHER_START =
  'REDEEM_STORE_VOUCHER_START';
export const REDEEM_STORE_VOUCHER_SUCCESS =
  'REDEEM_STORE_VOUCHER_SUCCESS';
export const CLEAR_CANCEL_TRANSACTION = 'CLEAR_CANCEL_TRANSACTION';
